import { Button } from "react-bootstrap";
import { Icon } from "react-bootstrap-icons";

interface CustomButtonProps {
    to: string;
    icon?: Icon;
    primary?: boolean;
    children: React.ReactNode;
}

export default function CustomButton({
    to,
    icon: IconComponent,
    primary,
    children,
}: CustomButtonProps) {
    return (
        <Button
            className="m-2 p-3 fw-bold d-inline-flex align-items-center gap-2"
            variant={primary ? "accent" : "outline-foreground"}
            size="lg"
            href={to}
        >
            {IconComponent && <IconComponent size={20} />}
            {children}
        </Button>
    );
}
